import { useEffect } from "react";
import { BCMSCurrency, BCMSDate, BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import { CardOnFileMerchant, Transaction, TransactionDispute } from "model";
import ViewAllTransactionsPage from "components/pages/ViewAllTransactionsPage";
import PurchasesView, { getDefaultData } from "components/pages/ViewAllTransactionsPage/components/PurchasesView";

export default function CaptureDisputeTransactionListUpdated(props) {
    const controller = useBCMSContext();
    const { branding } = useModel();
    const options = branding.options ?? {};
    let cardID = "1";
    let transactionID = "98"; // A credit card transaction id.
    if(options.include_credit_chw23 === "false") {
        cardID = "0";
        transactionID = "5"; // A debit card transaction id.
    }
    BCMSRecord.globalControllerFor([ Transaction, TransactionDispute ], controller);
    const defaultData = getDefaultData(cardID);
    const defaultTransactionDispute = BCMSDefaultModel.transactionDispute();
    
    const modifiedTransactions = defaultData.transactions.reduce((acc, transaction) => {
        // Init here to prevent modifying a property by reference.
        const transactionCopy = Transaction.init({ ...transaction.record });
        if(transaction.id === transactionID) {
            transactionCopy.transactionDispute = defaultTransactionDispute;
        }
        acc.push(transactionCopy);
        return acc;
    }, []);
    const data = BCMSStateManagerCRUD.init(defaultData)
    .update(["useDefaultViewForCapture"], true)
    .update(["transactions"], modifiedTransactions)
    .submit();

    // Modifies data point values so that different transactions
    // for different cards can be referenced by 1 endpoint label in capture states.
    useEffect(() => {
        const merchantNameDebit = document.querySelector('[data-point="Transaction_Row_5_Name_Label"]');
        const merchantNameCredit = document.querySelector('[data-point="Transaction_Row_98_Name_Label"]');
        const dataPoint = "Transaction_Row_Disputed_Transaction_Name_Label";

        if(merchantNameDebit) {
            merchantNameDebit.setAttribute("data-point", dataPoint);
        }
        if(merchantNameCredit) {
            merchantNameCredit.setAttribute("data-point", dataPoint);
        }
    });

    return (
        <ViewAllTransactionsPage data={ data }/>
    );
}
